export default {
  SET_CRITICAL_ERROR: '@YOLA_EDITOR/ERROR/SET_CRITICAL_ERROR',
  SET_NETWORK_STATUS: '@YOLA_EDITOR/ERROR/SET_NETWORK_STATUS',
};
